/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true,
 * }));
 */

/**
 * Vat Switch
 */
const mobileVatCheckbox = document.getElementById('inclvat_mobile');
const desktopVatCheckbox = document.getElementById('inclvat');
const vatState = document.documentElement.querySelector('[data-vat-state]');

if (mobileVatCheckbox && desktopVatCheckbox) {
  mobileVatCheckbox.addEventListener('change', () => {
    if (mobileVatCheckbox.checked) {
      desktopVatCheckbox.checked = true;
      updateCartAttributes({ _vat_state: 'true' });
      updatePrices('inclvat');
    } else {
      desktopVatCheckbox.checked = false;
      updateCartAttributes({ _vat_state: 'false' });
      updatePrices('exclvat');
    }
  });

  desktopVatCheckbox.addEventListener('change', () => {
    if (desktopVatCheckbox.checked) {
      mobileVatCheckbox.checked = true;
      updateCartAttributes({ _vat_state: 'true' });
      updatePrices('inclvat');
    } else {
      mobileVatCheckbox.checked = false;
      updateCartAttributes({ _vat_state: 'false' });
      updatePrices('exclvat');
    }
  });

  if (vatState && vatState.dataset.vatState === 'blank') {
    updateCartAttributes({ _vat_state: 'false' });
    updatePrices('exclvat');
    mobileVatCheckbox.checked = false;
    desktopVatCheckbox.checked = false;
  }
}

async function updateCartAttributes(attributes) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json;',
    },
    body: JSON.stringify({
      attributes: attributes,
    }),
  });
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
    }),
  );
}

/*
document.addEventListener('variant:change', () => {
  if (desktopVatCheckbox.checked || mobileVatCheckbox.checked) {
    setTimeout(function() {
      updatePrices('inclvat');
    }, 100)
    // updatePrices('inclvat')
  } else {
    setTimeout(function() {
      updatePrices('exclvat');
    }, 100)
    // updatePrices('exclvat')
  }
});
*/

function updatePrices(setting) {
  if (setting == 'inclvat') {
    document.querySelectorAll('.price__inclvat').forEach((e) => e.classList.remove('hidden'));
    document.querySelectorAll('.price__exclvat').forEach((e) => e.classList.add('hidden'));
  } else {
    document.querySelectorAll('.price__inclvat').forEach((e) => e.classList.add('hidden'));
    document.querySelectorAll('.price__exclvat').forEach((e) => e.classList.remove('hidden'));
  }
}
/**
 * CROSS-SELLING
 * */
class BBCrossSelling extends HTMLElement {
  connectedCallback() {
    this.taxRate = parseFloat(this.dataset.taxRate) || 1;

    this.fetchRecommendations().then(() => {
      this.renderValues();
    });

    document.addEventListener('cart:opened', () => {
      this.fetchRecommendations().then(() => {
        const deleteImage = this.querySelectorAll('rec-img img')[0];
        deleteImage.parentNode.removeChild(deleteImage);
        this.renderValues();
      });
    });
  }

  async fetchRecommendations() {
    // fetch /recommendations/products.json?product_id=
    const recommendations = await fetch(`${window.routes.productRecommendationsUrl}.json?product_id=${this.getAttribute('data-product-id')}`).then((response) => response.json());
    this.recommendation = recommendations.products[0];

    if (this.recommendation == undefined) {
      return;
    }
    this.variantId = this.recommendation.variants[0].id;
    this.selectedVariant = this.recommendation.variants.find((variant) => variant.id == this.variantId);
    this.updatedPrice = this.selectedVariant.price;
  }

  formatPrice(priceInCents) {
    const locale = [window?.Shopify?.locale, window?.Shopify?.country].filter(Boolean).join('-') || undefined;
    const currency = window?.Shopify?.currency?.active ?? 'EUR';

    const priceExclVat = priceInCents / 100;
    const priceInclVat = priceExclVat * this.taxRate;

    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    });

    return {
      exclVat: formatter.format(priceExclVat),
      inclVat: formatter.format(priceInclVat),
    };
  }

  updatePriceDisplay(priceInCents) {
    const prices = this.formatPrice(priceInCents);

    const priceInclVatElement = this.querySelector('[data-rec-price-inclvat]');
    const priceExclVatElement = this.querySelector('[data-rec-price-exclvat]');

    if (priceInclVatElement) {
      priceInclVatElement.textContent = prices.inclVat;
    }

    if (priceExclVatElement) {
      priceExclVatElement.textContent = prices.exclVat;
    }
  }

  renderValues() {
    if (this.recommendation == undefined) {
      this.classList.add('hidden');
      return;
    }
    this.classList.remove('hidden');
    Object.keys(this.recommendation).forEach((key) => {
      // key to kebab-case
      const kebapKey = key.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
      const element = this.querySelector(`rec-${key}`);
      if (element) {
        element.textContent = this.recommendation[key];
      }
    });

    // render variant select
    if (this.recommendation.variants.length > 1) {
      if (this.querySelector('rec-select').innerHTML != '') {
        return;
      } else {
        this.querySelectorAll('rec-select').forEach((select) => {
          select.innerHTML = `
            <select>
              ${this.recommendation.variants.map((variant) => `<option value="${variant.id}" ${variant.available ? `` : `disabled`} >${variant.title}</option>`).join('')}
            </select>
          `;
          select.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', (event) => {
              event.stopPropagation();
              this.variantId = parseInt(event.target.value);
              this.selectedVariant = this.recommendation.variants.find((variant) => variant.id == this.variantId);
              this.recommendation.price = this.selectedVariant.price;

              this.querySelectorAll('option').forEach((option) => {
                if (option.value == this.variantId) {
                  option.selected = true;
                }
              });

              if (this.selectedVariant.price) {
                this.updatePriceDisplay(this.selectedVariant.price);
              }
            });
          });
        });
      }
    }

    if (this.selectedVariant && this.selectedVariant.price) {
      this.updatePriceDisplay(this.selectedVariant.price);
    }

    // render image
    if (this.recommendation.featured_image) {
      this.querySelectorAll('rec-img').forEach((img) => {
        const imgComp = document.createElement('img');
        imgComp.src = this.recommendation.featured_image;
        imgComp.setAttribute('class', img.getAttribute('class'));
        img.removeAttribute('class');
        img.appendChild(imgComp);
      });
    }
  }

  async addToCart(elm) {
    elm.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.variantId,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      elm.setAttribute('aria-busy', 'false');

      this.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: null,
            quantity: 1,
          },
        }),
      );
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }
}
if (!customElements.get('bb-cross-selling')) {
  customElements.define('bb-cross-selling', BBCrossSelling);
}

class RecAtc extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.addToCart.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.addToCart.bind(this));
  }

  addToCart() {
    this.closest('bb-cross-selling').addToCart(this);
  }
}
if (!window.customElements.get('rec-atc')) {
  window.customElements.define('rec-atc', RecAtc);
}

class Search {
  static API_URL = '/search/suggest.json';

  static async search(q, config = {}) {
    console.debug('[BBBuyById][Search] Searching for:', q, config);
    const { type, limit, limitScope, unavailableProducts, fields } = config;
    const url = new URL(Search.API_URL, location.origin);
    url.searchParams.set('q', q);
    if (type) {
      url.searchParams.set('resources[type]', Array.isArray(type) ? type.join(',') : type);
    }
    if (limit) {
      url.searchParams.set('resources[limit]', limit.toString());
    }
    if (limitScope) {
      url.searchParams.set('resources[limit_scope]', limitScope);
    }
    if (unavailableProducts) {
      url.searchParams.set('resources[options][unavailable_products]', unavailableProducts);
    }
    if (fields) {
      url.searchParams.set('resources[options][fields]', Array.isArray(fields) ? fields.join(',') : fields);
    }
    console.debug('[BBBuyById][Search] Fetching URL:', url.href);
    return fetch(url.href).then((response) => response.json());
  }

  static async productSearchByHandle(handle) {
    const url = `/products/${handle}.js`;
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }
}

/**
 * CSV Parser for BB Import/Export functionality
 * Handles common CSV edge cases including quoted fields, escaped quotes, etc.
 */
class BBCSVParser {
  constructor() {
    this.delimiter = ',';
    this.quote = '"';
    this.lineEndings = ['\r\n', '\n', '\r'];
  }

  /**
   * Parse CSV string into array of arrays
   * @param {string} csvString - The CSV content as string
   * @returns {Array<Array<string>>} Parsed data as array of arrays
   */
  parse(csvString) {
    if (!csvString || typeof csvString !== 'string') {
      return [];
    }

    const rows = [];
    let currentRow = [];
    let currentField = '';
    let inQuotes = false;
    let i = 0;

    while (i < csvString.length) {
      const char = csvString[i];
      const nextChar = csvString[i + 1];

      // Handle quotes
      if (char === this.quote) {
        if (inQuotes) {
          // Check if it's an escaped quote
          if (nextChar === this.quote) {
            currentField += this.quote;
            i++; // Skip the next quote
          } else {
            // End of quoted field
            inQuotes = false;
          }
        } else {
          // Start of quoted field
          inQuotes = true;
        }
      }
      // Handle delimiter
      else if (char === this.delimiter && !inQuotes) {
        currentRow.push(this.trimField(currentField));
        currentField = '';
      }
      // Handle line endings
      else if (this.isLineEnding(char, nextChar) && !inQuotes) {
        currentRow.push(this.trimField(currentField));
        if (currentRow.length > 0 || rows.length === 0) {
          rows.push(currentRow);
        }
        currentRow = [];
        currentField = '';

        // Skip \r\n combination
        if (char === '\r' && nextChar === '\n') {
          i++;
        }
      }
      // Regular character
      else {
        currentField += char;
      }

      i++;
    }

    // Handle last field and row
    if (currentField !== '' || currentRow.length > 0) {
      currentRow.push(this.trimField(currentField));
      if (currentRow.length > 0) {
        rows.push(currentRow);
      }
    }

    return rows;
  }

  /**
   * Convert array of arrays to CSV string
   * @param {Array<Array<string|number>>} data - Data to convert
   * @returns {string} CSV formatted string
   */
  stringify(data) {
    if (!Array.isArray(data)) {
      return '';
    }

    return data
      .map((row) => {
        if (!Array.isArray(row)) {
          return '';
        }

        return row
          .map((field) => {
            const stringField = String(field || '');

            // Always quote all fields
            // Escape quotes within the field
            const escapedField = stringField.replace(/"/g, '""');
            return `"${escapedField}"`;
          })
          .join(this.delimiter);
      })
      .join('\r\n'); // Use CRLF for maximum compatibility
  }

  /**
   * Check if a character sequence is a line ending
   */
  isLineEnding(char, nextChar) {
    return char === '\n' || char === '\r';
  }

  /**
   * Trim field value and remove surrounding quotes if present
   */
  trimField(field) {
    let trimmed = field.trim();

    // Remove surrounding quotes if they exist and are matching
    if (trimmed.length >= 2 && trimmed[0] === this.quote && trimmed[trimmed.length - 1] === this.quote) {
      trimmed = trimmed.slice(1, -1);
    }

    // Replace escaped quotes
    return trimmed.replace(/""/g, '"');
  }

  /**
   * Detect if content is likely CSV
   * @param {string} content - File content to check
   * @returns {boolean}
   */
  static isLikelyCSV(content) {
    if (!content || typeof content !== 'string') {
      return false;
    }

    // Check for common CSV patterns
    const lines = content.split(/\r?\n/);
    if (lines.length < 2) {
      return false;
    }

    // Count delimiters in first few lines
    const delimiter = ',';
    const firstLineDelimiters = (lines[0].match(/,/g) || []).length;

    // If first line has delimiters and second line has similar count, likely CSV
    if (firstLineDelimiters > 0) {
      const secondLineDelimiters = (lines[1].match(/,/g) || []).length;
      return Math.abs(firstLineDelimiters - secondLineDelimiters) <= 1;
    }

    return false;
  }
}

/* BB NOTIFICATION */
class BBNotifications extends HTMLElement {
  constructor() {
    super();
    this.notifications = new Set();
    this.handleNotificationEvent = this.handleNotificationEvent.bind(this);
  }

  connectedCallback() {
    // Listen for notification events
    document.addEventListener('bb:notifications:show', this.handleNotificationEvent);
    document.addEventListener('bb:notifications:hide', this.handleNotificationEvent);
    document.addEventListener('bb:notifications:clear', this.handleNotificationEvent);
  }

  disconnectedCallback() {
    // Clean up event listeners
    document.removeEventListener('bb:notifications:show', this.handleNotificationEvent);
    document.removeEventListener('bb:notifications:hide', this.handleNotificationEvent);
    document.removeEventListener('bb:notifications:clear', this.handleNotificationEvent);

    // Remove all notifications
    this.removeAll();
  }

  handleNotificationEvent(event) {
    const { type, detail } = event;

    switch (type) {
      case 'bb:notifications:show':
        this.show(detail.message, detail.type, detail.duration);
        break;
      case 'bb:notifications:hide':
        if (detail.id) {
          this.removeById(detail.id);
        }
        break;
      case 'bb:notifications:clear':
        this.removeAll();
        break;
    }
  }

  show(message, type = 'info', duration = 10000) {
    const notification = this.createNotification(message, type, duration);
    const notificationId = this.generateId();
    notification.dataset.notificationId = notificationId;

    this.appendChild(notification);
    this.notifications.add(notification);

    // Trigger entrance animation
    requestAnimationFrame(() => {
      notification.classList.add('show');
    });

    // Auto-remove after duration
    const removeTimer = setTimeout(() => {
      this.remove(notification);
    }, duration);

    // Store timer reference for cleanup
    notification._removeTimer = removeTimer;

    return notificationId;
  }

  createNotification(message, type, duration) {
    const notification = document.createElement('div');
    notification.className = `bb-notification bb-notification--${type}`;

    // Create content container
    const content = document.createElement('div');
    content.className = 'bb-notification__content';

    // Parse message lines
    const lines = message.split('\n');
    lines.forEach((line, index) => {
      if (line.trim()) {
        const p = document.createElement('p');
        p.textContent = line;
        if (index === 0) {
          p.style.fontWeight = 'bold';
        }
        content.appendChild(p);
      }
    });

    // Create progress bar
    const progressBar = document.createElement('div');
    progressBar.className = 'bb-notification__progress';
    // Set CSS variable for animation duration
    progressBar.style.setProperty('--bb-progress-duration', `${duration}ms`);
    // Ensure position: relative for notification so ::before is positioned correctly

    notification.appendChild(content);
    notification.appendChild(progressBar);

    // Click to dismiss
    notification.addEventListener('click', () => {
      this.remove(notification);
    });

    return notification;
  }

  remove(notification) {
    if (!this.notifications.has(notification)) return;

    const notificationId = notification.dataset.notificationId;

    // Clear timer if exists
    if (notification._removeTimer) {
      clearTimeout(notification._removeTimer);
    }

    // Add exit animation
    notification.classList.add('hide');

    // Remove from DOM after animation
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
      this.notifications.delete(notification);

      // Dispatch event when notification is removed
      this.dispatchEvent(
        new CustomEvent('bb:notifications:removed', {
          bubbles: true,
          detail: { id: notificationId },
        }),
      );
    }, 300);
  }

  removeById(id) {
    const notification = Array.from(this.notifications).find((n) => n.dataset.notificationId === id);
    if (notification) {
      this.remove(notification);
    }
  }

  removeAll() {
    this.notifications.forEach((notification) => {
      this.remove(notification);
    });
  }

  generateId() {
    return `notification-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}

customElements.define('bb-notifications', BBNotifications);

/**
 * Shared XLSX loader for import/export
 */
let _sharedXLSX = null;
async function ensureXLSX(assetUrl) {
  if (_sharedXLSX) return _sharedXLSX;
  if (window.XLSX) {
    _sharedXLSX = window.XLSX;
    return _sharedXLSX;
  }
  const script = document.createElement('script');
  script.src = assetUrl;
  document.head.appendChild(script);
  await new Promise((resolve, reject) => {
    script.onload = () => {
      _sharedXLSX = window.XLSX;
      resolve();
    };
    script.onerror = reject;
  });
  return _sharedXLSX;
}

/* BB IMPORT */
class BBImport extends HTMLElement {
  constructor() {
    super();
    this.importButton = null;
    this.scanButton = null;
    this.scannerOverlay = null;
    this.scannerTarget = null;
    this.scannerStatus = null;
    this.scannerCloseButton = null;
    this.onDetectedHandler = null;
    this.scannerActive = false;
    this.scannerStarting = false;
    this.processingBarcode = false;
    this.resumeTimeout = null;
    this.overlayListenersAttached = false;

    this.handleImportListener = this.handleImport.bind(this);
    this.handleScanListener = this.handleScanButton.bind(this);
    this.handleCloseListener = () => this.closeScanner();
    this.handleOverlayListener = (event) => this.handleOverlayClick(event);
    this.handleDocumentScanListener = (event) => this.handleScanButton(event);
  }

  async connectedCallback() {
    this.importButton = this.querySelector('[data-import]');
    this.scanButton = this.querySelector('[data-scan]');

    if (this.importButton) {
      this.importButton.addEventListener('click', this.handleImportListener);
    }

    if (this.scanButton) {
      this.scanButton.addEventListener('click', this.handleScanListener);
    }

    this.xslxAssetUrl = this.dataset.xslxAssetUrl;

    document.addEventListener('bb:scan', this.handleDocumentScanListener);
  }

  disconnectedCallback() {
    if (this.importButton) {
      this.importButton.removeEventListener('click', this.handleImportListener);
    }

    if (this.scanButton) {
      this.scanButton.removeEventListener('click', this.handleScanListener);
    }

    document.removeEventListener('bb:scan', this.handleDocumentScanListener);

    this.stopScanner();
    this.detachOverlayListeners();
  }

  async handleImport() {
    try {
      // Create and trigger file input
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.xlsx,.xls,.csv';

      fileInput.addEventListener('change', async (e) => {
        const file = e.target.files[0];
        if (file) {
          await this.processFile(file);
        } else {
          // User cancelled file selection
          this.setButtonState('default');
        }
      });

      // User cancelled file selection
      fileInput.addEventListener('cancel', () => {
        this.setButtonState('default');
      });

      this.setButtonState('selecting');
      fileInput.click();
    } catch (error) {
      console.error('Import error:', error);
      this.showNotification(this.getText('error-loading'), 'error', 5000);
      this.setButtonState('error');
      setTimeout(() => this.setButtonState('default'), 3000);
    }
  }

  async handleScanButton(event) {
    event.preventDefault();
    if (this.scannerActive || this.scannerStarting) return;

    this.scannerStarting = true;

    try {
      await this.startScanner();
    } catch (error) {
      console.warn('[BBImport] Scanner unavailable, falling back to image picker:', error);
      try {
        await this.handleImagePickerFallback();
      } catch (fallbackError) {
        console.error('[BBImport] Image picker fallback failed:', fallbackError);
        this.showNotification(this.getText('error-scan'), 'error', 5000);
      }
    } finally {
      this.scannerStarting = false;
      this.setScanButtonLoading(false);
    }
  }

  async startScanner() {
    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
      throw new Error('Camera access is not supported in this browser');
    }

    const overlay = document.querySelector('[data-bb-scanner-overlay]');

    if (!overlay) {
      throw new Error('Scanner overlay not found in document');
    }

    this.scannerOverlay = overlay;
    this.scannerTarget = overlay.querySelector('[data-bb-scanner-target]');
    this.scannerStatus = overlay.querySelector('[data-bb-scanner-status]');
    this.scannerCloseButton = overlay.querySelector('[data-bb-scanner-close]');

    this.openScannerOverlay();
    this.attachOverlayListeners();
    this.updateScannerStatus(this.getText('starting-camera') || 'Starting camera...');

    this.setScanButtonLoading(true);

    const Quagga = await BBImport.loadQuagga();

    if (this.scannerTarget) {
      this.scannerTarget.innerHTML = '';
    }

    return new Promise((resolve, reject) => {
      const config = {
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          target: this.scannerTarget,
          constraints: {
            facingMode: 'environment',
            aspectRatio: { min: 1, max: 2 },
          },
        },
        locator: {
          patchSize: 'medium',
          halfSample: true,
        },
        decoder: {
          readers: ['ean_reader', 'ean_8_reader', 'code_128_reader', 'code_39_reader', 'code_39_vin_reader', 'codabar_reader', 'upc_reader', 'upc_e_reader', 'i2of5_reader'],
        },
        locate: true,
      };

      Quagga.init(config, (err) => {
        if (err) {
          reject(err);
          return;
        }

        this.scannerActive = true;
        this.updateScannerStatus(this.getText('scanner-instruction') || 'Align the barcode with the frame');

        if (typeof Quagga.start === 'function') {
          Quagga.start();
        }

        this.onDetectedHandler = (result) => this.handleBarcodeDetected(result);

        if (typeof Quagga.onDetected === 'function') {
          Quagga.onDetected(this.onDetectedHandler);
        }

        resolve();
      });
    }).catch((error) => {
      this.showNotification(this.getText('error-scan'), 'info', 5000);
      this.closeScanner();
      throw error;
    });
  }

  handleOverlayClick(event) {
    if (event.target === this.scannerOverlay) {
      this.closeScanner();
    }
  }

  closeScanner() {
    this.stopScanner();

    if (this.scannerOverlay) {
      this.scannerOverlay.classList.remove('is-active');
      this.scannerOverlay.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('bb-import__scanner-open');
    this.detachOverlayListeners();

    this.setScanButtonLoading(false);
    this.scanButton?.focus();
  }

  stopScanner() {
    if (this.resumeTimeout) {
      clearTimeout(this.resumeTimeout);
      this.resumeTimeout = null;
    }

    const Quagga = window.Quagga;

    if (Quagga && typeof Quagga.offDetected === 'function' && this.onDetectedHandler) {
      Quagga.offDetected(this.onDetectedHandler);
    }

    if (Quagga && typeof Quagga.stop === 'function') {
      try {
        Quagga.stop();
      } catch (error) {
        console.warn('[BBImport] Quagga stop warning:', error);
      }
    }

    this.onDetectedHandler = null;
    this.scannerActive = false;
    this.scannerStarting = false;
    this.processingBarcode = false;

    if (this.scannerTarget) {
      this.scannerTarget.innerHTML = '';
    }
  }

  attachOverlayListeners() {
    if (!this.scannerOverlay || this.overlayListenersAttached) {
      return;
    }

    this.scannerOverlay.addEventListener('click', this.handleOverlayListener);
    if (this.scannerCloseButton) {
      this.scannerCloseButton.addEventListener('click', this.handleCloseListener);
    }

    this.overlayListenersAttached = true;
  }

  detachOverlayListeners() {
    if (!this.scannerOverlay || !this.overlayListenersAttached) {
      return;
    }

    this.scannerOverlay.removeEventListener('click', this.handleOverlayListener);
    if (this.scannerCloseButton) {
      this.scannerCloseButton.removeEventListener('click', this.handleCloseListener);
    }

    this.overlayListenersAttached = false;
  }

  openScannerOverlay() {
    if (!this.scannerOverlay) return;

    this.scannerOverlay.classList.add('is-active');
    this.scannerOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bb-import__scanner-open');
    this.updateScannerStatus(this.getText('scanner-instruction') || 'Align the barcode with the frame');
  }

  setScanButtonLoading(loading) {
    if (!this.scanButton) return;

    if (loading) {
      this.scanButton.disabled = true;
      this.scanButton.setAttribute('data-loading', 'true');
    } else {
      this.scanButton.disabled = false;
      this.scanButton.removeAttribute('data-loading');
    }
  }

  updateScannerStatus(message) {
    if (this.scannerStatus) {
      this.scannerStatus.textContent = message || '';
    }
  }

  async handleBarcodeDetected(result) {
    if (!result || !result.codeResult || !result.codeResult.code || this.processingBarcode) {
      return;
    }

    const Quagga = window.Quagga;
    this.processingBarcode = true;

    if (Quagga && typeof Quagga.pause === 'function') {
      Quagga.pause();
    }

    const rawCode = result.codeResult.code;
    const processingTemplate = this.getText('scanner-processing');
    this.updateScannerStatus(processingTemplate.replace('{{ code }}', rawCode));

    try {
      const isSuccess = await this.processBarcodeResult(rawCode);

      if (isSuccess) {
        this.updateScannerStatus(this.getText('button-success'));
        setTimeout(() => this.closeScanner(), 600);
        return;
      }

      this.updateScannerStatus(this.getText('product-not-found'));
    } catch (error) {
      console.error('[BBImport] Error processing barcode:', error);
      this.showNotification(this.getText('error-processing'), 'error', 5000);
      this.updateScannerStatus(this.getText('error-processing'));
    } finally {
      this.processingBarcode = false;

      if (Quagga && typeof Quagga.start === 'function') {
        this.resumeTimeout = setTimeout(() => {
          Quagga.start();
          this.resumeTimeout = null;
          this.updateScannerStatus(this.getText('scanner-instruction'));
        }, 800);
      }
    }
  }

  async processBarcodeResult(rawCode) {
    const barcode = this.normalizeBarcode(rawCode);

    if (!barcode) {
      return false;
    }

    console.debug('[BBImport] Searching for barcode:', barcode);

    const searchResponse = await Search.search(barcode, {
      type: 'product',
      fields: ['variants.barcode'],
      limit: 6,
      limitScope: 'each',
      unavailableProducts: 'hide',
    });

    const productResults = searchResponse?.resources?.results?.products || [];

    if (productResults.length === 0) {
      return false;
    }

    const detailedProducts = await Promise.all(productResults.map((product) => Search.productSearchByHandle(product.handle)));
    let matchingVariant = null;

    for (const product of detailedProducts) {
      if (!product || !Array.isArray(product.variants)) continue;

      matchingVariant = product.variants.find((variant) => this.normalizeBarcode(variant.barcode) === barcode);

      if (matchingVariant) {
        break;
      }
    }

    if (!matchingVariant) {
      return false;
    }

    const added = await this.addProductsToCart([{ variantId: matchingVariant.id, quantity: 1 }]);

    if (!added) {
      this.showNotification(this.getText('error-processing'), 'error', 5000);
      return false;
    }

    const successTemplate = this.getText('notification-success');
    const successMessage = successTemplate.includes('{{ count }}') ? successTemplate.replace('{{ count }}', '1') : successTemplate;

    this.showNotification(successMessage, 'success', 4000);

    document.documentElement.dispatchEvent(
      new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: { id: matchingVariant.id }, quantity: 1 },
      }),
    );

    return true;
  }

  normalizeBarcode(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  async handleImagePickerFallback() {
    this.setScanButtonLoading(true);

    const Quagga = await BBImport.loadQuagga();

    return new Promise((resolve, reject) => {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/*';
      fileInput.capture = 'environment';
      fileInput.style.display = 'none';

      const cleanup = () => {
        fileInput.remove();
        this.processingBarcode = false;
        this.setScanButtonLoading(false);
        this.scanButton?.focus();
      };

      const handleNoResult = () => {
        cleanup();
        this.showNotification(this.getText('no-barcode-found'), 'error', 4000);
        resolve(false);
      };

      fileInput.addEventListener('change', async (event) => {
        const file = event.target?.files?.[0];
        if (!file) {
          handleNoResult();
          return;
        }

        this.processingBarcode = true;

        const reader = new FileReader();
        reader.addEventListener('error', () => {
          cleanup();
          reject(new Error('Failed to read selected image'));
        });

        reader.addEventListener('load', async (evt) => {
          const src = evt.target?.result;
          if (!src) {
            handleNoResult();
            return;
          }

          try {
            Quagga.decodeSingle(
              {
                decoder: {
                  readers: [
                    'ean_reader',
                    'ean_8_reader',
                    'code_128_reader',
                    'code_39_reader',
                    'code_39_vin_reader',
                    'codabar_reader',
                    'upc_reader',
                    'upc_e_reader',
                    'i2of5_reader',
                  ],
                },
                locate: true,
                src,
              },
              async (result) => {
                try {
                  if (result?.codeResult?.code) {
                    const success = await this.processBarcodeResult(result.codeResult.code);
                    cleanup();
                    if (!success) {
                      this.showNotification(this.getText('product-not-found'), 'error', 4000);
                    }
                    resolve(success);
                  } else {
                    handleNoResult();
                  }
                } catch (error) {
                  cleanup();
                  reject(error);
                }
              },
            );
          } catch (error) {
            cleanup();
            reject(error);
          }
        });

        reader.readAsDataURL(file);
      });

      fileInput.addEventListener('cancel', () => {
        handleNoResult();
      });

      document.body.appendChild(fileInput);
      fileInput.click();
    });
  }

  static loadQuagga() {
    if (window.Quagga) {
      return Promise.resolve(window.Quagga);
    }

    if (!BBImport._quaggaPromise) {
      BBImport._quaggaPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/@ericblade/quagga2/dist/quagga.min.js';

        script.addEventListener('load', () => {
          if (window.Quagga) {
            resolve(window.Quagga);
          } else {
            BBImport._quaggaPromise = null;
            reject(new Error('Barcode reader unavailable'));
          }
        });

        script.addEventListener('error', () => {
          BBImport._quaggaPromise = null;
          reject(new Error('Failed to load barcode reader'));
        });

        document.head.appendChild(script);
      });
    }

    return BBImport._quaggaPromise;
  }

  async processFile(file) {
    try {
      this.setButtonState('processing');

      // Detect file type by extension
      const fileName = file.name.toLowerCase();
      const isCSV = fileName.endsWith('.csv');
      const isXLSX = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');

      let rows;

      if (isCSV) {
        rows = await this.processCSVFile(file);
      } else if (isXLSX) {
        rows = await this.processXLSXFile(file);
      } else {
        throw new Error('Unsupported file type');
      }

      // Process rows (common logic for both CSV and XLSX)
      await this.processImportedData(rows);
    } catch (error) {
      console.error('File processing error:', error);
      this.showNotification(this.getText('error-processing'), 'error', 5000);
      this.setButtonState('error');
      setTimeout(() => this.setButtonState('default'), 3000);
    }
  }

  async processCSVFile(file) {
    const text = await file.text();
    const parser = new BBCSVParser();
    return parser.parse(text);
  }

  async processXLSXFile(file) {
    // Load XLSX library dynamically (shared)
    const XLSX = await ensureXLSX(this.xslxAssetUrl);

    // Read file
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    // Get first worksheet
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];

    // Convert to array of arrays
    return XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  }

  async processImportedData(rows) {
    // Process rows (skip header if exists)
    const startIndex = this.isHeaderRow(rows[0]) ? 1 : 0;
    const items = [];

    // Extract SKUs and quantities
    for (let i = startIndex; i < rows.length; i++) {
      const row = rows[i];
      if (!row || row.length < 2) continue; // Skip empty rows

      const sku = String(row[0] || '').trim();
      const quantity = parseInt(row[1], 10) || 1;

      if (!sku) continue; // Skip rows without SKU

      items.push({ sku, quantity });
    }

    if (items.length === 0) {
      this.showNotification(this.getText('no-valid-products'), 'error', 5000);
      this.setButtonState('error');
      setTimeout(() => this.setButtonState('default'), 3000);
      return;
    }

    // Send items to server endpoint for validation
    const validationResponse = await fetch('/apps/bb-orgatex/importCart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    });

    if (!validationResponse.ok) {
      throw new Error('Validation request failed');
    }

    const { processedItems } = await validationResponse.json();

    // Filter processed items by type
    const addable = processedItems.filter((item) => item.type === 'product-addable');
    const notFound = processedItems.filter((item) => item.type === 'product-not-found');
    const notAddable = processedItems.filter((item) => item.type === 'product-not-enough-quantity' || item.type === 'product-not-active' || item.type === 'product-not-available');

    console.debug('Validation results:', { addable, notFound, notAddable });

    // Add products to cart if any were found
    if (addable.length > 0) {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const added = await this.addProductsToCart(addable);

      if (added) {
        this.showImportResults(addable, notFound, notAddable);

        // Determine button state based on results
        if (notFound.length === 0 && notAddable.length === 0) {
          // this.setButtonState('success');
          // doesn't really do anything currently since cart is refreshing ergo button being put to default state, I think notification is enough for now
        } else {
          this.setButtonState('warning');
        }
      } else {
        // If cart add failed, treat all addable items as not addable
        this.showImportResults([], notFound, [...notAddable, ...addable]);
        this.setButtonState('error');
      }

      setTimeout(() => this.setButtonState('default'), 3000);
    } else {
      this.showImportResults([], notFound, notAddable);
      this.setButtonState('error');
      setTimeout(() => this.setButtonState('default'), 3000);
    }
  }

  isHeaderRow(row) {
    if (!row || row.length === 0) return false;
    // Check if first cell contains common header terms
    const firstCell = String(row[0]).toLowerCase();
    return firstCell.includes('artikelnummer') || firstCell.includes('menge') || firstCell.includes('sku') || firstCell.includes('quantity');
  }

  async addProductsToCart(products) {
    try {
      const items = products.map((p) => ({
        id: p.variantId,
        quantity: p.quantity,
      }));

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        return false;
      }

      // Refresh cart after successful add
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        }),
      );

      return true;
    } catch (error) {
      console.error('Cart add error:', error);
      return false;
    }
  }

  showImportResults(added, notFound, foundButNotAddable) {
    let message = '';
    let type = 'success';
    let duration = 8000; // Default duration

    const addedCount = added.length;
    const notFoundCount = notFound.length;
    const notAddableCount = foundButNotAddable.length;
    const totalFailed = notFoundCount + notAddableCount;

    // Determine message type and content
    if (addedCount > 0 && totalFailed === 0) {
      // Only successful adds
      message = this.getText('notification-success').replace('{{ count }}', addedCount);
      type = 'success';
      duration = 5000; // Shorter duration for success
    } else if (addedCount === 0 && totalFailed > 0) {
      // Only failures
      message = this.getText('notification-error-all-failed');
      type = 'error';
      duration = 10000; // Longer duration for errors
    } else if (addedCount > 0 && totalFailed > 0) {
      // Mix of success and failures
      message = this.getText('notification-warning-partial').replace('{{ successCount }}', addedCount).replace('{{ failedCount }}', totalFailed);
      type = 'warning';
      duration = 12000; // Longer duration for detailed warnings
    }

    // Add details about not found products
    if (notFoundCount > 0) {
      message += '\n\n' + this.getText('product-not-found-header').replace('{{ count }}', notFoundCount);

      notFound.forEach((item) => {
        message += `\n• ${item.sku} (${this.getText('product-quantity')}: ${item.quantity}): ${this.getText('product-not-found')}`;
      });
    }

    if (notAddableCount > 0) {
      message += '\n\n' + this.getText('product-not-addable-header').replace('{{ count }}', notAddableCount);

      foundButNotAddable.forEach((item) => {
        const reason = this.getText(item.type);
        message += `\n• ${item.sku} (${this.getText('product-quantity')}: ${item.quantity})${reason != '' ? `: ${reason}` : ''}`;
      });
    }

    this.showNotification(message, type, duration);
  }

  showNotification(message, type = 'info', duration = 10000) {
    // Dispatch notification event instead of directly showing notification
    document.dispatchEvent(
      new CustomEvent('bb:notifications:show', {
        detail: { message, type, duration },
      }),
    );
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }

  setButtonState(state) {
    this.importButton.setAttribute('data-state', state);
    this.importButton.disabled = state === 'loading' || state === 'processing' || state === 'selecting';
  }
}

customElements.define('bb-import', BBImport);

/**
 * EXPORT
 */
class BBExport extends HTMLElement {
  constructor() {
    super();
    this.exportXLSXButton = null;
    this.exportCSVButton = null;
  }

  async connectedCallback() {
    // Support both old and new button selectors
    this.exportXLSXButton = this.querySelector('[data-export-xlsx], [data-export]');
    this.exportCSVButton = this.querySelector('[data-export-csv]');

    this.xslxAssetUrl = this.dataset.xslxAssetUrl;

    if (this.exportXLSXButton) {
      this.exportXLSXButton.addEventListener('click', () => this.handleExport('xlsx'));
    }

    if (this.exportCSVButton) {
      this.exportCSVButton.addEventListener('click', () => this.handleExport('csv'));
    }
  }

  async handleExport(format = 'xlsx') {
    try {
      this.setButtonState('loading', format);

      const cart = await fetch('/cart.js').then((r) => r.json());
      const items = cart.items || [];

      // Prepare data for export
      const header = [this.getText('column-sku'), this.getText('column-qty'), this.getText('column-unit-price'), this.getText('column-total')];

      const data = [header];

      items.forEach((item) => {
        const price = typeof item.price === 'number' ? item.price / 100 : 0;
        const quantity = item.quantity || 0;
        const total = price * quantity;

        // Always use de-DE/EUR for formatting as requested
        const formattedPrice = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
        }).format(price);
        const formattedTotal = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
        }).format(total);

        data.push([item.sku || '', quantity, formattedPrice, formattedTotal]);
      });

      if (format === 'csv') {
        await this.exportAsCSV(data);
      } else {
        await this.exportAsXLSX(data);
      }

      this.showNotification(this.getText(format === 'csv' ? 'success-csv' : 'success'), 'success', 5000);

      this.setButtonState('success', format);
      setTimeout(() => this.setButtonState('default', format), 2000);
    } catch (err) {
      console.error('Export error:', err);
      this.setButtonState('error', format);
      setTimeout(() => this.setButtonState('default', format), 2000);
    }
  }

  getFormattedDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    // Detect locale from document lang or default to EN
    const locale = document.documentElement.lang || 'en';
    const isGerman = locale.toLowerCase().includes('de');

    // Format: DE uses DD-MM-YYYY, EN uses YYYY-MM-DD
    if (isGerman) {
      return `${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;
    } else {
      return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    }
  }

  async exportAsXLSX(data) {
    const XLSX = await ensureXLSX(this.xslxAssetUrl);

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Warenkorb');

    const baseFilename = this.getText('filename');
    const dateTime = this.getFormattedDateTime();
    const filename = `${baseFilename}_${dateTime}.xlsx`;

    XLSX.writeFile(wb, filename);
  }

  async exportAsCSV(data) {
    const parser = new BBCSVParser();
    const csvContent = parser.stringify(data);

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    const baseFilename = this.getText('filename-csv') || this.getText('filename');
    const dateTime = this.getFormattedDateTime();
    const filename = `${baseFilename}_${dateTime}.csv`;

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up
    setTimeout(() => URL.revokeObjectURL(url), 100);
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }

  setButtonState(state, format = 'xlsx') {
    const button = format === 'csv' ? this.exportCSVButton : this.exportXLSXButton;
    if (!button) return;

    button.setAttribute('data-state', state);
    button.disabled = state === 'loading';
  }

  showNotification(message, type = 'info', duration = 10000) {
    // Dispatch notification event instead of directly showing notification
    document.dispatchEvent(
      new CustomEvent('bb:notifications:show', {
        detail: { message, type, duration },
      }),
    );
  }
}

customElements.define('bb-export', BBExport);

/**
 * SHARE AND PRINT
 */

class BBShareAndPrint extends HTMLElement {
  async connectedCallback() {
    this.shareButton = this.querySelector('[data-share]');
    this.printButton = this.querySelector('[data-print]');
    this.scanButton = this.querySelector('[data-scan]');

    // Use getText for all texts
    this.navigatorText = this.getText('navigator');
    this.language = document.documentElement.lang || 'de';

    if (this.shareButton) {
      this.shareButton.addEventListener('click', this.handleShare.bind(this));
      // Set button text
      const shareTextElm = this.shareButton.querySelector('.share-and-print__button-text');
      if (shareTextElm) shareTextElm.textContent = this.getText('share');
    }

    if (this.printButton) {
      this.printButton.addEventListener('click', this.handlePrint.bind(this));
      // Set button text
      const printTextElm = this.printButton.querySelector('.share-and-print__button-text');
      if (printTextElm) printTextElm.textContent = this.getText('print');
    }

    if (this.scanButton) {
      this.scanButton.addEventListener('click', async (event) => {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('bb:scan'));
      });
    }

    const hash = window.location.hash;
    console.debug('[BBShareAndPrint] Checking hash:', hash);
    if (hash.startsWith('#cart-') && !this.importing) {
      window.location.hash = '';
      console.debug('[BBShareAndPrint] Hash indicates cart import:', hash);
      await fetch(`${location.origin}${window.Shopify?.routes?.root ?? ''}${window.Shopify?.routes?.locale ?? ''}/cart/clear.js`);
      const base64 = hash.replace('#cart-', '');
      const json = atob(base64);
      const items = JSON.parse(json);

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        }),
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:open', {
          bubbles: true,
        }),
      );
    }
  }

  async handleShare() {
    if (this.shareButton.getAttribute('data-pressed') === 'true') return;

    // Get cart data from the new print-data script tag
    const printDataScript = this.querySelector('script[print-data]');
    if (!printDataScript) {
      console.error('Print data not found for sharing');
      return;
    }

    const printData = JSON.parse(printDataScript.textContent);
    const items = printData.items.map((item) => ({ id: item.id, quantity: item.quantity }));
    const json = JSON.stringify(items);
    const base64 = btoa(json);

    try {
      await navigator.share({
        text: this.navigatorText,
        url: `${window.Shopify?.routes?.root ?? window.location.origin}#cart-${base64}`,
        title: this.navigatorText,
      });
    } catch (e) {
      await navigator.clipboard.writeText(`${window.Shopify?.routes?.root ?? window.location.origin}#cart-${base64}`);
    }
    this.showCheckmark(this.shareButton);
  }

  async handlePrint() {
    if (this.printButton.getAttribute('data-pressed') === 'true') return;

    this.setLoadingState(this.printButton, true);

    try {
      // Get print data from the new script tag
      const printDataScript = this.querySelector('script[print-data]');
      if (!printDataScript) {
        throw new Error('Print data not found');
      }

      const printData = JSON.parse(printDataScript.textContent);

      // Map items to the format expected by the print endpoint
      const quoteItems = printData.items.map((item) => ({
        sku: item.sku || '',
        title: item.title,
        variantTitle: item.variantTitle || null,
        description: item.description || null,
        quantity: item.quantity,
        price: item.price,
        linePrice: item.linePrice,
        verpackungsmenge: item.verpackungsmenge || null,
        verpackungseinheit: item.verpackungseinheit || null,
        inhaltseinheit: item.inhaltseinheit || null,
      }));

      // Prepare the request body
      const requestBody = {
        items: quoteItems,
        language: this.language,
        countryCode: printData.countryCode || null,
      };

      // Add customer data if available
      if (printData.customer) {
        requestBody.customer = printData.customer;
      }

      // Add B2B conditions if available
      if (printData.deliveryCondition) {
        requestBody.deliveryCondition = printData.deliveryCondition;
      }
      if (printData.paymentCondition) {
        requestBody.paymentCondition = printData.paymentCondition;
      }
      if (printData.carrier) {
        requestBody.carrier = printData.carrier;
      }
      if (printData.deliveryDays) {
        requestBody.deliveryDays = printData.deliveryDays;
      }

      const printResponse = await fetch('/apps/bb-orgatex/printQuote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!printResponse.ok) {
        throw new Error('Failed to generate quote');
      }

      const blob = await printResponse.blob();

      const now = new Date();
      let dateTimeStr;
      if (this.language === 'de') {
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        dateTimeStr = `${day}.${month}.${year}_${hours}-${minutes}`;
      } else {
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        dateTimeStr = `${year}-${month}-${day}_${hours}-${minutes}`;
      }

      const filenamePrefix = this.getText('filename-prefix');

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${filenamePrefix}_${dateTimeStr}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      this.setLoadingState(this.printButton, false);
      this.showCheckmark(this.printButton);
      const successMessage = this.getText('print-success');
      document.dispatchEvent(
        new CustomEvent('bb:notifications:show', {
          detail: { message: successMessage, type: 'success', duration: 5000 },
        }),
      );
    } catch (error) {
      console.error('Error generating quote:', error);
      this.setLoadingState(this.printButton, false);
      const errorMessage = this.getText('print-error');
      document.dispatchEvent(
        new CustomEvent('bb:notifications:show', {
          detail: { message: errorMessage, type: 'error', duration: 5000 },
        }),
      );
    }
  }

  setLoadingState(button, isLoading) {
    if (isLoading) {
      button.setAttribute('data-loading', 'true');
      button.disabled = true;
    } else {
      button.removeAttribute('data-loading');
      button.disabled = false;
    }
  }

  showCheckmark(button) {
    button.setAttribute('data-pressed', 'true');
    setTimeout(() => {
      button.setAttribute('data-pressed', 'false');
    }, 3000);
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }
}

if (!customElements.get('bb-share-and-print')) {
  customElements.define('bb-share-and-print', BBShareAndPrint);
}
/**
 * BUY BY ID
 */
class BBBuyById extends HTMLElement {
  constructor() {
    super();
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleQuantityPlus = this.handleQuantityPlus.bind(this);
    this.handleQuantityMinus = this.handleQuantityMinus.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('[data-buy-by-id-variant]');
    this.qtyInput = this.querySelector('[data-buy-by-id-quantity]');
    this.addBtn = this.querySelector('[data-buy-by-id-add]');
    this.errorElm = this.querySelector('[data-buy-by-id-error]');
    this.plusBtn = this.querySelector('[data-buy-by-id-quantity-plus]');
    this.minusBtn = this.querySelector('[data-buy-by-id-quantity-minus]');

    this.addBtn.addEventListener('click', this.handleAddToCart);
    this.qtyInput.addEventListener('change', this.handleQuantityChange);
    this.plusBtn.addEventListener('click', this.handleQuantityPlus);
    this.minusBtn.addEventListener('click', this.handleQuantityMinus);
    // Add: Enter key in artikelnummer field triggers add to cart
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.handleAddToCart(e);
      }
    });
  }

  disconnectedCallback() {
    this.addBtn.removeEventListener('click', this.handleAddToCart);
    this.qtyInput.removeEventListener('change', this.handleQuantityChange);
    this.plusBtn.removeEventListener('click', this.handleQuantityPlus);
    this.minusBtn.removeEventListener('click', this.handleQuantityMinus);
  }

  async handleAddToCart(e) {
    e.preventDefault();
    this.errorElm.classList.add('hidden');
    const articleNumber = this.input.value.trim();
    const quantity = parseInt(this.qtyInput.value, 10) || 1;
    // Get error texts from data attributes
    const errorTextNotFound = this.getText('error-not-found');
    const errorTextEmpty = this.getText('error-empty');
    console.debug('[BBBuyById] Add to cart clicked:', { articleNumber, quantity });
    if (!articleNumber || typeof articleNumber !== 'string' || articleNumber.length === 0) {
      this.showError(errorTextEmpty);
      return;
    }

    let variant = null;
    try {
      const searchResponse = await Search.search(articleNumber.trim().toLowerCase(), {
        type: 'product',
        fields: ['variants.sku'],
        limit: 1,
        limitScope: 'each',
        unavailableProducts: 'hide',
      });

      if (!searchResponse || !(searchResponse?.resources?.results?.products?.length > 0)) {
        console.debug('[BBBuyById] No search response for article number:', articleNumber);
        this.showError(errorTextNotFound);
        return;
      }

      const results = await Promise.all(searchResponse.resources.results.products.map((p) => Search.productSearchByHandle(p.handle)));

      variant = results.reduce((acc, product) => {
        if (acc) return acc;
        if (!product || !product.variants) return acc;
        const found = product.variants.find((v) => v.sku.trim().toLowerCase() === articleNumber.trim().toLowerCase());
        return found || acc;
      }, null);

      if (!variant) {
        console.debug('[BBBuyById] No variant found for article number:', articleNumber);
        return;
      }

      this.addBtn.setAttribute('loading', '');
      const addResult = await this.addToCartShopify(variant.id, quantity);
      this.addBtn.removeAttribute('loading');

      if (addResult.error) {
        console.debug('[BBBuyById] Error adding to cart:', addResult.error);
        this.showError(addResult.error);
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: { id: variant.id }, quantity },
        }),
      );
      this.input.value = '';
      this.qtyInput.value = 1;
    } catch (err) {
      console.error('[BBBuyById] Error adding to cart:', err);
      this.showError(errorTextNotFound);
    }
  }

  async addToCartShopify(variantId, quantity) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        return { error: error.description };
      }
      return { success: true };
    } catch (e) {
      return { error: 'Error adding to cart' };
    }
  }

  handleQuantityChange(e) {
    let val = parseInt(this.qtyInput.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    this.qtyInput.value = val;
    console.debug('[BBBuyById] Quantity changed:', val);
  }

  handleQuantityPlus(e) {
    e.preventDefault();
    let val = parseInt(this.qtyInput.value, 10) || 1;
    this.qtyInput.value = val + 1;
    console.debug('[BBBuyById] Quantity incremented:', this.qtyInput.value);
  }

  handleQuantityMinus(e) {
    e.preventDefault();
    let val = parseInt(this.qtyInput.value, 10) || 1;
    if (val > 1) this.qtyInput.value = val - 1;
    console.debug('[BBBuyById] Quantity decremented:', this.qtyInput.value);
  }

  showError(msg) {
    this.errorElm.textContent = msg;
    this.errorElm.classList.remove('hidden');
    console.warn('[BBBuyById] Error shown:', msg);
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }
}

if (!window.customElements.get('bb-buy-by-id')) {
  window.customElements.define('bb-buy-by-id', BBBuyById);
}

/**
 * ProductList Class
 * Manages product lists (wishlist/compare) with event tracking and storage
 */
class ProductList {
  constructor(storageKey) {
    this.storageKey = storageKey;
    this.list = [];
    this.trackListeners = new Map();
    this.changeListeners = [];
    this.updateTimeout = null;
    this.isUpdating = false;
    this.pendingUpdate = false;
    this.maxProducts = storageKey === '_bb_compare_products' ? 4 : undefined;

    // Initialize from cart attributes script tag
    this.initializeFromCartAttributes();
  }

  initializeFromCartAttributes() {
    const jsonScriptElement = document.querySelector('script[data-cart-attributes]');
    if (jsonScriptElement) {
      try {
        const attributes = JSON.parse(jsonScriptElement.textContent || '{}');
        this.list = attributes[this.storageKey]?.split(';').filter(Boolean) || [];
      } catch (error) {
        console.error('[ProductList] Error parsing cart attributes:', error);
        this.list = [];
      }
    } else {
      this.list = [];
    }
  }

  hasEntry(productHandle) {
    return this.list.includes(productHandle);
  }

  notifyListeners(productHandle, isOnList) {
    const trackListeners = this.trackListeners.get(productHandle);
    if (trackListeners) {
      trackListeners.forEach((listener) => listener(isOnList));
    }

    this.changeListeners.forEach((listener) => listener([...this.list]));
  }

  async add(productHandle) {
    if (this.hasEntry(productHandle)) return;

    if (this.maxProducts && this.list.length >= this.maxProducts) {
      const error = new Error('Maximum number of products reached');
      error.reason = 'error_max_reached';
      throw error;
    }

    this.list.push(productHandle);
    await this.updateStorage();
    this.notifyListeners(productHandle, true);
  }

  async remove(productHandle) {
    if (!this.hasEntry(productHandle)) return;

    this.list = this.list.filter((handle) => handle !== productHandle);
    await this.updateStorage();
    this.notifyListeners(productHandle, false);
  }

  // Set the entire list (useful for URL-based lists)
  async setList(handles) {
    try {
      this.list = [...handles]; // Create a copy
      await this.updateStorage();

      this.changeListeners.forEach((listener) => listener([...this.list]));
    } catch (error) {
      console.error(`[ProductList:${this.type}] Error setting list:`, error);
      throw error;
    }
  }

  async clear() {
    const oldList = [...this.list];
    this.list = [];

    await this.updateStorage();

    // Notify all tracked products they're removed
    oldList.forEach((handle) => {
      const trackListeners = this.trackListeners.get(handle);
      if (trackListeners) {
        trackListeners.forEach((listener) => listener(false));
      }
    });

    this.changeListeners.forEach((listener) => listener([]));
  }

  getList() {
    return [...this.list];
  }

  track(productHandle, listener) {
    if (!this.trackListeners.has(productHandle)) {
      this.trackListeners.set(productHandle, []);
    }
    this.trackListeners.get(productHandle).push(listener);

    listener(this.hasEntry(productHandle));

    return () => {
      const listeners = this.trackListeners.get(productHandle);
      if (listeners) {
        const index = listeners.indexOf(listener);
        if (index > -1) {
          listeners.splice(index, 1);
        }
        if (listeners.length === 0) {
          this.trackListeners.delete(productHandle);
        }
      }
    };
  }

  onChange(listener) {
    this.changeListeners.push(listener);

    listener([...this.list]);

    return () => {
      const index = this.changeListeners.indexOf(listener);
      if (index > -1) {
        this.changeListeners.splice(index, 1);
      }
    };
  }

  async updateStorage() {
    // Clear any existing timeout
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = null;
    }

    // If currently updating, mark that another update is pending
    if (this.isUpdating) {
      this.pendingUpdate = true;
      return;
    }

    // Debounce the update by 300ms
    return new Promise((resolve, reject) => {
      this.updateTimeout = window.setTimeout(async () => {
        this.updateTimeout = null;
        try {
          await this.performUpdate();
          resolve();
        } catch (error) {
          reject(error);
        }
      }, 300);
    });
  }

  async performUpdate() {
    this.isUpdating = true;
    this.pendingUpdate = false;

    const fetchUrl = '/cart/update.js';
    const body = JSON.stringify({
      attributes: {
        [this.storageKey]: this.list.join(';'),
      },
    });

    try {
      const response = await fetch(fetchUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error(`Failed to update list: ${response.statusText}`);
      }
    } catch (error) {
      console.error('[ProductList] Error updating storage:', error);
      throw error;
    } finally {
      this.isUpdating = false;

      // If there was a pending update while we were updating, perform it now
      if (this.pendingUpdate) {
        await this.performUpdate();
      }
    }
  }
}

// Global instances
const wishlistManager = new ProductList('_bb_wishlist_products');
const compareManager = new ProductList('_bb_compare_products');
class ProductItem extends HTMLElement {
  constructor() {
    super();
    this.card = this;
    this.wishlistButton = null;
    this.compareButton = null;
    this.wishlistUnsubscribe = null;
    this.compareUnsubscribe = null;
  }

  async connectedCallback() {
    if (!this.card) return;

    await this.initializeWishlist();
    await this.initializeCompare();
  }

  disconnectedCallback() {
    if (this.wishlistUnsubscribe) {
      this.wishlistUnsubscribe();
      this.wishlistUnsubscribe = null;
    }
    if (this.compareUnsubscribe) {
      this.compareUnsubscribe();
      this.compareUnsubscribe = null;
    }
  }

  async initializeWishlist() {
    this.wishlistButton = this.card.querySelector('.card__wishlist-button');

    if (!this.wishlistButton) return;

    const handle = this.wishlistButton.dataset.handle;
    if (!handle) return;

    // Track state changes
    this.wishlistUnsubscribe = wishlistManager.track(handle, (isOnList) => {
      this.setWishlistButtonState(isOnList ? 'added' : 'add');
    });

    this.wishlistButton.addEventListener('click', async () => {
      await this.handleWishlistButtonClick(handle);
    });
  }

  async initializeCompare() {
    this.compareButton = this.card.querySelector('.card__compare-button');

    if (!this.compareButton) return;

    const handle = this.compareButton.dataset.handle;
    if (!handle) return;

    // Track state changes
    this.compareUnsubscribe = compareManager.track(handle, (isOnList) => {
      this.setCompareButtonState(isOnList ? 'added' : 'add');
    });

    this.compareButton.addEventListener('click', async () => {
      await this.handleCompareButtonClick(handle);
    });
  }

  async handleWishlistButtonClick(handle) {
    try {
      if (this.wishlistButton.getAttribute('data-state') === 'loading') return;

      this.setWishlistButtonState('loading');

      const hasEntry = wishlistManager.hasEntry(handle);

      if (hasEntry) {
        await wishlistManager.remove(handle);
        this.showNotification(this.getText('success-removed-wishlist'), 'success');
      } else {
        await wishlistManager.add(handle);
        this.showNotification(this.getText('success-added-wishlist'), 'success');
      }
    } catch (error) {
      console.error('[ProductItem] Error handling wishlist button click:', error);
      const hasEntry = wishlistManager.hasEntry(handle);
      this.setWishlistButtonState(hasEntry ? 'added' : 'add');
      this.showNotification(this.getText('error-updating'), 'error');
    }
  }

  setWishlistButtonState(state) {
    const addContent = this.wishlistButton.querySelector('[data-wishlist-add]');
    const addedContent = this.wishlistButton.querySelector('[data-wishlist-added]');
    const loadingContent = this.wishlistButton.querySelector('[data-wishlist-loading]');

    addContent?.classList.add('hidden');
    addedContent?.classList.add('hidden');
    loadingContent?.classList.add('hidden');

    switch (state) {
      case 'added':
        this.wishlistButton.disabled = false;
        this.wishlistButton.setAttribute('data-state', 'added');
        addedContent?.classList.remove('hidden');
        break;
      case 'loading':
        this.wishlistButton.disabled = true;
        this.wishlistButton.setAttribute('data-state', 'loading');
        loadingContent?.classList.remove('hidden');
        break;
      default:
        this.wishlistButton.disabled = false;
        this.wishlistButton.setAttribute('data-state', 'add');
        addContent?.classList.remove('hidden');
        break;
    }
  }

  async handleCompareButtonClick(handle) {
    try {
      if (this.compareButton.getAttribute('data-state') === 'loading') return;

      this.setCompareButtonState('loading');

      const hasEntry = compareManager.hasEntry(handle);

      if (hasEntry) {
        await compareManager.remove(handle);
        this.showNotification(this.getText('success-removed-compare'), 'success');
      } else {
        await compareManager.add(handle);
        this.showNotification(this.getText('success-added-compare'), 'success');
      }
    } catch (error) {
      console.error('[ProductItem] Error handling compare button click:', error);

      const hasEntry = compareManager.hasEntry(handle);
      this.setCompareButtonState(hasEntry ? 'added' : 'add');
      const errorMessage = this.getText(error.reason === 'error_max_reached' ? 'error-max-reached' : 'error-updating');
      this.showNotification(errorMessage, 'error');
    }
  }

  setCompareButtonState(state) {
    const addContent = this.compareButton.querySelector('[data-compare-add]');
    const addedContent = this.compareButton.querySelector('[data-compare-added]');
    const loadingContent = this.compareButton.querySelector('[data-compare-loading]');

    addContent?.classList.add('hidden');
    addedContent?.classList.add('hidden');
    loadingContent?.classList.add('hidden');

    switch (state) {
      case 'added':
        this.compareButton.disabled = false;
        this.compareButton.setAttribute('data-state', 'added');
        addedContent?.classList.remove('hidden');
        break;
      case 'loading':
        this.compareButton.disabled = true;
        this.compareButton.setAttribute('data-state', 'loading');
        loadingContent?.classList.remove('hidden');
        break;
      default:
        this.compareButton.disabled = false;
        this.compareButton.setAttribute('data-state', 'add');
        addContent?.classList.remove('hidden');
        break;
    }
  }

  showNotification(message, type = 'info') {
    const event = new CustomEvent('bb:notifications:show', {
      bubbles: true,
      detail: { message, type },
    });
    document.dispatchEvent(event);
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }
}
if (!customElements.get('product-item')) {
  customElements.define('product-item', ProductItem);
}

/**
 * Base Grid Component for Wishlist and Compare functionality
 * Shared functionality between wishlist-grid and compare-grid
 */
class BaseGridComponent extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.loadingTimeout = null;
  }

  setLoadingState(loading) {
    this.isLoading = loading;
    this.setAttribute('data-loading', loading.toString());

    // Disable interactive elements during loading
    const interactiveElements = this.querySelectorAll('button, input');
    interactiveElements.forEach((el) => {
      el.disabled = loading;
    });

    if (loading) {
      // Clear any existing timeout
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
      }
      // Set timeout to prevent infinite loading state
      this.loadingTimeout = setTimeout(() => {
        this.setLoadingState(false);
      }, 10000);
    } else {
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
    }
  }

  async reloadPage() {
    // Try to use Section Rendering API for better performance
    try {
      const sectionHandle = this.getAttribute('data-section-handle');
      if (sectionHandle) {
        const response = await fetch(`${window.location.pathname}?sections=${sectionHandle}`);
        if (response.ok) {
          const data = await response.json();
          if (data[sectionHandle]) {
            // Create a temporary container to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data[sectionHandle];

            // Find the new grid element
            const newGrid = tempDiv.querySelector(this.tagName.toLowerCase());
            if (newGrid) {
              // Replace the current element's content
              // Browser automatically cleans up old event listeners when innerHTML is replaced
              this.innerHTML = newGrid.innerHTML;

              // Re-setup event listeners
              this.setupRemoveButtons();
              this.setupEventListeners();
              return;
            }
          }
        }
      }
    } catch (error) {
      console.warn(`[${this.tagName}] Section rendering failed, falling back to page reload:`, error);
    }

    // Fallback to full page reload
    window.location.reload();
  }

  setupRemoveButtons() {
    throw new Error('setupRemoveButtons must be implemented by subclass');
  }

  setupEventListeners() {
    throw new Error('setupEventListeners must be implemented by subclass');
  }

  disconnectedCallback() {
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
  }

  showNotification(message, type = 'info', duration = 10000) {
    document.dispatchEvent(
      new CustomEvent('bb:notifications:show', {
        detail: { message, type, duration },
      }),
    );
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }
}

class ShopWishlistGrid extends BaseGridComponent {
  constructor() {
    super();
    this.unsubscribe = null;
  }

  async connectedCallback() {
    this.grid = this.querySelector('[data-grid]');

    if (window.location.hash.includes('#wishlist-')) {
      await this.handleUrlBasedWishlist();
    } else {
      this.setupRemoveButtons();
    }

    this.setupEventListeners();

    // Subscribe to wishlist changes to refresh grid
    this.unsubscribe = wishlistManager.onChange(() => {
      this.reloadPage();
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  setupRemoveButtons() {
    this.querySelectorAll('[data-remove-from-wishlist]').forEach((elm) => {
      elm.addEventListener('click', async (evt) => {
        evt.preventDefault();
        await this.handleRemoveProduct(elm);
      });
    });
  }

  setupEventListeners() {
    const shareButton = document.querySelector('[data-wishlist-share]');
    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        await this.shareWishlist();
      });
      shareButton.addEventListener('keypress', async (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          await this.shareWishlist();
        }
      });
    }
  }

  async handleRemoveProduct(button) {
    if (this.isLoading) return;

    const handle = button.dataset.removeFromWishlist;
    if (!handle) return;

    this.setLoadingState(true);
    button.disabled = true;
    button.setAttribute('data-loading', 'true');

    try {
      await wishlistManager.remove(handle);
      await this.reloadPage();
    } catch (error) {
      console.error('[ShopWishlistGrid] Error removing product:', error);
      this.showNotification(this.getText('error-removing'), 'error');
      button.disabled = false;
      button.removeAttribute('data-loading');
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleUrlBasedWishlist() {
    const hash = window.location.hash.replace('#wishlist-', '');
    const decoded = decodeURIComponent(hash);
    const handles = decoded.split(';').filter(Boolean);

    if (handles.length > 0) {
      this.setLoadingState(true);
      try {
        // Clear current list and add new handles
        await wishlistManager.setList(handles);
      } catch (error) {
        console.error('[ShopWishlistGrid] Error loading from URL:', error);
        this.showNotification(this.getText('error-loading'), 'error');
      } finally {
        this.setLoadingState(false);
      }
    }
  }

  async reloadPage() {
    if (window.location.hash.includes('#wishlist-')) {
      window.history.replaceState(null, null, window.location.pathname + window.location.search);
    }

    // Call parent method for Section Rendering API
    await super.reloadPage();
  }

  async shareWishlist() {
    const list = wishlistManager.getList();
    const encoded = encodeURIComponent(list.join(';'));
    const shareText = this.getText('share-text');
    const shareTitle = this.getText('share-title');

    if (window.location.hash.includes('#wishlist-')) {
      try {
        await navigator.share({
          text: shareText,
          url: `${window.location.href}`,
          title: shareTitle,
        });
      } catch (e) {
        await navigator.clipboard.writeText(`${window.location.href}`);
        this.showNotification(this.getText('link-copied'), 'success');
      }
    } else {
      try {
        await navigator.share({
          text: shareText,
          url: `${window.location.href}#wishlist-${encoded}`,
          title: shareTitle,
        });
      } catch (e) {
        await navigator.clipboard.writeText(`${window.location.href}#wishlist-${encoded}`);
        this.showNotification(this.getText('link-copied'), 'success');
      }
    }
  }
}
if (!customElements.get('wishlist-grid')) {
  customElements.define('wishlist-grid', ShopWishlistGrid);
}

class WishlistButtons extends HTMLElement {
  constructor() {
    super();
    this.pbWishlist = this.querySelector('button');
    this.pbWishlistAdd = this.querySelector('[data-wishlist-add]');
    this.pbWishlistAdded = this.querySelector('[data-wishlist-added]');
    this.isLoading = false;
    this.unsubscribe = null;
  }

  async connectedCallback() {
    const handle = this.pbWishlist?.dataset.handle;
    if (!handle) return;

    this.pbWishlist.addEventListener('click', async () => {
      await this.handlePbButton();
    });

    // Subscribe to wishlist changes
    this.unsubscribe = wishlistManager.track(handle, (isOnList) => {
      this.updateButtonState(isOnList);
    });
  }

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  async handlePbButton() {
    // Prevent multiple clicks during loading
    if (this.isLoading) return;

    const handle = this.pbWishlist.dataset.handle;
    if (handle == null) return;

    // Set loading state
    this.setLoadingState(true);

    try {
      const hasEntry = wishlistManager.hasEntry(handle);

      if (hasEntry) {
        await wishlistManager.remove(handle);
      } else {
        await wishlistManager.add(handle);
      }
    } catch (error) {
      console.error('[WishlistButtons] Error handling button click:', error);
      // Reset button state on error and show notification
      const hasEntry = wishlistManager.hasEntry(handle);
      this.updateButtonState(hasEntry);
      const errorMessage = this.getText('error-updating');
      this.showNotification(errorMessage, 'error');
    } finally {
      // Clear loading state
      this.setLoadingState(false);
    }
  }

  updateButtonState(hasEntry) {
    if (hasEntry) {
      this.pbWishlist.classList.remove('button-wishlist-add');
      this.pbWishlist.classList.add('button-wishlist-added');
      this.pbWishlistAdd.classList.add('hidden');
      this.pbWishlistAdded.classList.remove('hidden');
    } else {
      this.pbWishlist.classList.remove('button-wishlist-added');
      this.pbWishlist.classList.add('button-wishlist-add');
      this.pbWishlistAdd.classList.remove('hidden');
      this.pbWishlistAdded.classList.add('hidden');
    }

    // Clear loading state when updating from subscription
    this.setLoadingState(false);
  }

  setLoadingState(loading) {
    this.isLoading = loading;

    if (loading) {
      this.pbWishlist.disabled = true;
      this.pbWishlist.classList.add('button-wishlist-loading');
      this.pbWishlist.setAttribute('data-loading', 'true');
    } else {
      this.pbWishlist.disabled = false;
      this.pbWishlist.classList.remove('button-wishlist-loading');
      this.pbWishlist.removeAttribute('data-loading');
    }
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }

  showNotification(message, type = 'info') {
    const event = new CustomEvent('bb:notifications:show', {
      bubbles: true,
      detail: { message, type },
    });
    document.dispatchEvent(event);
  }
}
if (!customElements.get('wishlist-buttons')) {
  customElements.define('wishlist-buttons', WishlistButtons);
}

class ShopCompareGrid extends BaseGridComponent {
  constructor() {
    super();
    this.currentHighlightMode = null; // null, 'similarities', 'differences'
    this.unsubscribe = null;
  }

  async connectedCallback() {
    // Initialize all element references
    this.addByIdButton = this.querySelector('[data-compare-add-by-id]');
    this.grid = this.querySelector('[data-compare-products-grid]');
    this.addByIdInput = this.querySelector('[data-compare-add-by-id-input]');
    this.removeAllButton = this.querySelector('[data-compare-remove-all]');
    this.highlightSimilaritiesButton = this.querySelector('[data-highlight-similarities]');
    this.highlightDifferencesButton = this.querySelector('[data-highlight-differences]');
    this.compareFilter = this.querySelector('[data-compare-filter]');

    // Initialize page based on URL hash or init event Listeners
    if (window.location.hash.includes('#compare-')) {
      await this.handleUrlBasedCompare();
    } else {
      this.setupRemoveButtons();
    }

    this.setupEventListeners();

    // Subscribe to compare changes to refresh grid
    this.unsubscribe = compareManager.onChange(() => {
      this.reloadPage();
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  setupRemoveButtons() {
    this.querySelectorAll('[data-remove-from-compare]').forEach((elm) => {
      elm.addEventListener('click', async (evt) => {
        evt.preventDefault();
        await this.handleRemoveProduct(elm);
      });
    });
  }

  setupEventListeners() {
    // Re-initialize button references in case DOM changed
    this.addByIdButton = this.querySelector('[data-compare-add-by-id]');
    this.addByIdInput = this.querySelector('[data-compare-add-by-id-input]');
    this.removeAllButton = this.querySelector('[data-compare-remove-all]');
    this.highlightSimilaritiesButton = this.querySelector('[data-highlight-similarities]');
    this.highlightDifferencesButton = this.querySelector('[data-highlight-differences]');
    this.compareFilter = this.querySelector('[data-compare-filter]');
    this.grid = this.querySelector('[data-compare-products-grid]');

    const shareButton = document.querySelector('[data-compare-share]');
    if (shareButton) {
      shareButton.addEventListener('click', async () => {
        await this.shareCompare();
      });
    }

    if (this.addByIdButton) {
      this.addByIdButton.addEventListener('click', () => this.handleAddById());
    }

    if (this.addByIdInput) {
      this.addByIdInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.handleAddById();
        }
      });
    }

    if (this.removeAllButton) {
      this.removeAllButton.addEventListener('click', () => this.handleRemoveAll());
    }

    if (this.highlightSimilaritiesButton) {
      this.highlightSimilaritiesButton.addEventListener('click', () => this.handleHighlightSimilarities());
    }

    if (this.highlightDifferencesButton) {
      this.highlightDifferencesButton.addEventListener('click', () => this.handleHighlightDifferences());
    }
  }

  async handleRemoveProduct(button) {
    if (this.isLoading) return;

    const handle = button.dataset.removeFromCompare;
    if (!handle) return;

    this.setLoadingState(true);
    button.disabled = true;
    button.setAttribute('data-loading', 'true');

    try {
      await compareManager.remove(handle);
      this.showNotification(this.getText('success-removed'), 'success');
      await this.reloadPage();
    } catch (error) {
      console.error('[ShopCompareGrid] Error removing product:', error);
      this.showNotification(this.getText('error-removing'), 'error');
      button.disabled = false;
      button.removeAttribute('data-loading');
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleRemoveAll() {
    if (this.isLoading) return;

    this.setLoadingState(true);

    try {
      await compareManager.clear();
      this.showNotification(this.getText('success-cleared'), 'success');
      await this.reloadPage();
    } catch (error) {
      console.error('[ShopCompareGrid] Error clearing compare list:', error);
      this.showNotification(this.getText('error-clearing'), 'error');
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleAddById() {
    if (this.isLoading) return;

    const articleNumber = this.addByIdInput.value.trim();

    if (!articleNumber) {
      this.showNotification(this.getText('error-empty'), 'error');
      return;
    }

    this.setLoadingState(true);

    try {
      // Check if we're at max capacity
      const currentList = compareManager.getList();
      if (currentList.length >= 4) {
        this.showNotification(this.getText('error-max-reached'), 'error');
        return;
      }

      let variant = null;
      let searchResponse = await Search.search(articleNumber.trim().toLowerCase(), {
        type: 'product',
        fields: ['variants.sku'],
        limit: 1,
        limitScope: 'each',
        unavailableProducts: 'hide',
      });

      const products = [];

      if (searchResponse?.resources?.results?.products.length > 0) {
        products.push(...searchResponse.resources.results.products);
      }

      if (!variant && products.length > 0) {
        const results = await Promise.all(products.map((p) => Search.productSearchByHandle(p.handle)));
        for (const product of results) {
          if (!product || !product.variants) continue;
          const found = product.variants.find((v) => v.sku.trim().toLowerCase() === articleNumber.trim().toLowerCase());
          if (found) {
            await compareManager.add(product.handle);
            await this.reloadPage();
            this.addByIdInput.value = '';
            this.showNotification(this.getText('success-added'), 'success');
            return;
          }
        }
      }

      this.showNotification(this.getText('error-not-found'), 'error');
    } catch (err) {
      console.error('[ShopCompareGrid] Error adding product:', err);
      this.showNotification(err.message || this.getText('error-not-found'), 'error');
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleUrlBasedCompare() {
    const hash = window.location.hash.replace('#compare-', '');
    const decoded = decodeURIComponent(hash);
    const handles = decoded.split(';').filter(Boolean);

    if (handles.length > 0) {
      this.setLoadingState(true);
      try {
        // Update cart attributes with URL handles
        await compareManager.setList(handles);
        // Reload page to show server-rendered content
        await this.reloadPage();
      } catch (error) {
        console.error('[ShopCompareGrid] Error loading from URL:', error);
        this.showNotification(this.getText('error-loading'), 'error');
      } finally {
        this.setLoadingState(false);
      }
    }
  }

  async reloadPage() {
    // Remove hash to prevent conflicts
    if (window.location.hash.includes('#compare-')) {
      window.history.replaceState(null, null, window.location.pathname + window.location.search);
    }

    // Call parent method for Section Rendering API
    await super.reloadPage();
  }

  handleHighlightSimilarities() {
    if (this.currentHighlightMode === 'similarities') {
      this.clearHighlights();
      this.currentHighlightMode = null;
      this.updateButtonStates();
    } else {
      this.highlightSimilarities();
      this.currentHighlightMode = 'similarities';
      this.updateButtonStates();
    }
  }

  handleHighlightDifferences() {
    if (this.currentHighlightMode === 'differences') {
      this.clearHighlights();
      this.currentHighlightMode = null;
      this.updateButtonStates();
    } else {
      this.highlightDifferences();
      this.currentHighlightMode = 'differences';
      this.updateButtonStates();
    }
  }

  updateButtonStates() {
    const similaritiesBtn = this.highlightSimilaritiesButton;
    const differencesBtn = this.highlightDifferencesButton;

    if (similaritiesBtn) {
      similaritiesBtn.classList.toggle('is--active', this.currentHighlightMode === 'similarities');
    }
    if (differencesBtn) {
      differencesBtn.classList.toggle('is--active', this.currentHighlightMode === 'differences');
    }
  }

  highlightSimilarities() {
    this.clearHighlights();
    const rows = this.getComparisonRows();

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll('.compare-keyvalue__value'));
      if (cells.length <= 1) return;

      const values = cells.map((cell) => this.normalizeValue(cell.textContent.trim()));
      const allSame = values.every((value) => value === values[0]);

      if (allSame) {
        cells.forEach((cell) => {
          cell.style.background = 'var(--primary-button-background)';
          cell.style.color = 'var(--primary-button-text-color)';
          cell.setAttribute('data-highlighted', 'similarity');
        });
      }
    });
  }

  highlightDifferences() {
    this.clearHighlights();
    const rows = this.getComparisonRows();

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll('.compare-keyvalue__value'));
      if (cells.length <= 1) return;

      const values = cells.map((cell) => this.normalizeValue(cell.textContent.trim()));
      const allSame = values.every((value) => value === values[0]);

      if (!allSame) {
        cells.forEach((cell) => {
          cell.style.background = 'var(--primary-button-background)';
          cell.style.color = 'var(--primary-button-text-color)';
          cell.setAttribute('data-highlighted', 'difference');
        });
      }
    });
  }

  clearHighlights() {
    const highlightedCells = this.grid?.querySelectorAll('[data-highlighted]');
    highlightedCells?.forEach((cell) => {
      cell.style.background = '';
      cell.style.color = '';
      cell.removeAttribute('data-highlighted');
    });
  }

  getComparisonRows() {
    if (!this.grid) return [];
    const allRows = Array.from(this.grid.querySelectorAll('tr.compare-keyvalue'));
    return allRows.slice(1); // Skip the first row with product images/titles
  }

  normalizeValue(value) {
    return value.toLowerCase().trim() || '';
  }

  async shareCompare() {
    const list = compareManager.getList();
    const encoded = encodeURIComponent(list.join(';'));
    const shareText = this.getText('share-text');
    const shareTitle = this.getText('share-title');

    try {
      await navigator.share({
        text: shareText,
        url: `${window.location.origin}${window.location.pathname}#compare-${encoded}`,
        title: shareTitle,
      });
    } catch (e) {
      await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}#compare-${encoded}`);
      this.showNotification(this.getText('link-copied'), 'success');
    }
  }
}

if (!customElements.get('compare-grid')) {
  customElements.define('compare-grid', ShopCompareGrid);
}

class CompareButtons extends HTMLElement {
  constructor() {
    super();
    this.pbCompare = this.querySelector('button');
    this.pbCompareAdd = this.querySelector('[data-compare-add]');
    this.pbCompareAdded = this.querySelector('[data-compare-added]');
    this.pbCompareLoading = this.querySelector('[data-compare-loading]');
    this.isLoading = false;
    this.unsubscribe = null;
  }

  async connectedCallback() {
    const handle = this.pbCompare?.dataset.handle;
    if (!handle) return;

    this.pbCompare.addEventListener('click', async () => {
      await this.handlePbButton();
    });

    // Subscribe to compare changes
    this.unsubscribe = compareManager.track(handle, (isOnList) => {
      this.updateButtonState(isOnList ? 'added' : 'add');
    });
  }

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  async handlePbButton() {
    if (this.isLoading) return;

    const handle = this.pbCompare.dataset.handle;
    if (handle == null) return;

    this.updateButtonState('loading');

    try {
      const hasEntry = compareManager.hasEntry(handle);

      if (hasEntry) {
        await compareManager.remove(handle);
      } else {
        await compareManager.add(handle);
      }
    } catch (error) {
      // Differentiate between max products reached and other errors
      let errorKey;
      if (error.reason === 'error_max_reached') {
        errorKey = 'error-max-reached';
      } else {
        errorKey = 'error-updating';
      }

      const hasEntry = compareManager.hasEntry(handle);
      this.updateButtonState(hasEntry ? 'added' : 'add');

      const errorMessage = this.getText(errorKey);
      this.showNotification(errorMessage, 'error');
    }
  }

  updateButtonState(state) {
    if (!this.pbCompare) return;

    this.pbCompare.classList.remove('button-compare-add', 'button-compare-added', 'button-compare-loading');
    this.pbCompare.disabled = false;
    this.pbCompare.removeAttribute('data-loading');

    this.pbCompareAdd?.classList.add('hidden');
    this.pbCompareAdded?.classList.add('hidden');
    this.pbCompareLoading?.classList.add('hidden');

    switch (state) {
      case 'added':
        this.isLoading = false;
        this.pbCompare.classList.add('button-compare-added');
        this.pbCompareAdded?.classList.remove('hidden');
        break;

      case 'loading':
        this.isLoading = true;
        this.pbCompare.classList.add('button-compare-loading');
        this.pbCompare.disabled = true;
        this.pbCompare.setAttribute('data-loading', 'true');
        this.pbCompareLoading?.classList.remove('hidden');
        break;

      default:
        this.isLoading = false;
        this.pbCompare.classList.add('button-compare-add');
        this.pbCompareAdd?.classList.remove('hidden');
        break;
    }
  }

  getText(key) {
    return this.getAttribute(`data-${key}-text`) || '';
  }

  showNotification(message, type = 'info') {
    const event = new CustomEvent('bb:notifications:show', {
      bubbles: true,
      detail: { message, type },
    });
    document.dispatchEvent(event);
  }
}
if (!customElements.get('compare-buttons')) {
  customElements.define('compare-buttons', CompareButtons);
}

class BBPricing extends HTMLElement {
  constructor() {
    super();
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  connectedCallback() {
    try {
      this.unitsPerQuantity = parseInt(this.getAttribute('data-units-per-quantity') || '1');
      this.hasBulkPricing = this.getAttribute('data-has-bulk-pricing') === 'true';

      if (this.hasBulkPricing) {
        try {
          const quantitiesStr = this.getAttribute('data-bulk-quantities') || '';
          if (quantitiesStr) {
            this.bulkTiers = quantitiesStr
              .split(';')
              .map((qty) => ({
                minQuantity: parseInt(qty.trim()),
              }))
              .filter((tier) => !isNaN(tier.minQuantity));

            // Sort tiers by minimum quantity for proper tier detection
            this.bulkTiers.sort((a, b) => a.minQuantity - b.minQuantity);
          } else {
            this.bulkTiers = [];
          }
        } catch (error) {
          console.error('Error parsing bulk pricing data:', error);
          this.hasBulkPricing = false;
        }
      }

      this.quantityInput = this.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
      this.quantityInfoDiv = this.querySelector('[data-quantity-info]');

      this.currentTier = 'default';

      this.updateTotalUnits();
      this.setupEventListeners();
      this.showElements();

      if (this.hasBulkPricing) {
        this.updateBulkPricing();
      }
    } catch (e) {
      console.error('Error initializing BBPricing:', e);
    }
  }

  disconnectedCallback() {
    if (this.quantityInput) {
      this.quantityInput.removeEventListener('input', this.handleQuantityChange);
      this.quantityInput.removeEventListener('change', this.handleQuantityChange);
    }
  }

  showElements() {
    if (this.quantityInfoDiv) {
      this.quantityInfoDiv.classList.remove('hidden');
    }
  }

  setupEventListeners() {
    if (!this.quantityInput) {
      console.warn('BBPricing: quantity input not found');
      return;
    }

    this.quantityInput.addEventListener('input', this.handleQuantityChange);
    this.quantityInput.addEventListener('change', this.handleQuantityChange);
  }

  handleQuantityChange() {
    this.updateTotalUnits();
    if (this.hasBulkPricing) {
      this.updateBulkPricing();
    }
  }

  updateTotalUnits() {
    if (!this.quantityInput) return;

    const quantity = parseInt(this.quantityInput.value) || 1;
    const totalUnits = quantity * this.unitsPerQuantity;

    const totalQtyElements = document.querySelectorAll('[data-pr-total-qty]');
    totalQtyElements.forEach((element) => {
      element.textContent = totalUnits;
    });

    const singularElements = document.querySelectorAll('[data-unit-singular]');
    const pluralElements = document.querySelectorAll('[data-unit-plural]');
    if (totalUnits === 1) {
      singularElements.forEach((el) => el.classList.remove('hidden'));
      pluralElements.forEach((el) => el.classList.add('hidden'));
    } else {
      singularElements.forEach((el) => el.classList.add('hidden'));
      pluralElements.forEach((el) => el.classList.remove('hidden'));
    }
  }

  updateBulkPricing() {
    if (!this.hasBulkPricing || !this.quantityInput) return;

    const quantity = parseInt(this.quantityInput.value) || 1;
    const newTier = this.getBulkTier(quantity);

    if (newTier !== this.currentTier) {
      this.currentTier = newTier;
      this.switchPricingTier(newTier);
    }
  }

  getBulkTier(quantity) {
    let activeTier = 'default';

    // Find the highest tier that the quantity qualifies for
    for (const tier of this.bulkTiers) {
      if (quantity >= tier.minQuantity) {
        activeTier = tier.minQuantity.toString();
      }
    }

    return activeTier;
  }

  switchPricingTier(tier) {
    console.debug('[BBPricing] Switching to tier:', tier);

    const allTierElements = document.querySelectorAll('[data-pr-tier]');
    allTierElements.forEach((tierElement) => {
      if (tierElement.dataset.prTier !== tier) {
        tierElement.classList.add('hidden');
      } else {
        tierElement.classList.remove('hidden');
      }
    });
  }
}

if (!customElements.get('bb-pricing')) {
  customElements.define('bb-pricing', BBPricing);
}

/**
 * Product page block "BB Stock" (snippets/product-info.liquid): swaps the in-stock text for the partial delivery text
 * ("3 Stk. versandfertig am nächsten Werktag, Rest Lieferzeit: …") while the quantity field holds more than the stock.
 * Partial re-renders of the block on variant change reconnect the element, so it reads the new stock then. Its own
 * product form scopes the quantity field: quick view modals render inside the collection or cart section, next to the
 * hidden quantity fields of the product cards.
 */
class BBStockPartial extends HTMLElement {
  constructor() {
    super();
    this.update = this.update.bind(this);
    // quantity-picker corrects invalid values in its own change/focusout handlers without firing an event, read after it
    this.scheduleUpdate = () => setTimeout(this.update);
  }

  connectedCallback() {
    this.stock = parseInt(this.dataset.stock, 10);
    const scope = this.closest('form') || this.closest('.shopify-section') || document;
    this.quantityInput = scope.querySelector('input[name="quantity"]');
    if (!this.quantityInput || isNaN(this.stock)) return;

    ['input', 'change', 'focusout'].forEach((type) => this.quantityInput.addEventListener(type, this.scheduleUpdate));
    this.update();
  }

  disconnectedCallback() {
    if (!this.quantityInput) return;
    ['input', 'change', 'focusout'].forEach((type) => this.quantityInput.removeEventListener(type, this.scheduleUpdate));
  }

  update() {
    const quantity = parseInt(this.quantityInput.value, 10) || 1;
    const isPartial = quantity > this.stock;
    this.querySelector('[data-stock-full]')?.classList.toggle('hidden', isPartial);
    this.querySelector('[data-stock-partial]')?.classList.toggle('hidden', !isPartial);
  }
}

if (!customElements.get('bb-stock-partial')) {
  customElements.define('bb-stock-partial', BBStockPartial);
}

class BBWorldMap extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    let settings;
    try {
      settings = JSON.parse(this.getAttribute('data-section-settings'));
    } catch (e) {
      settings = {};
    }

    const mapContainer = this.querySelector('.world-map__container');
    if (!mapContainer) return;

    const countryBlocks = this.querySelectorAll('.world-map__country-data');
    const values = {};
    const tooltipContent = {};

    countryBlocks.forEach((el) => {
      const code = el.getAttribute('data-country');
      if (!code) return;

      const entry = { presence: 1 };
      const color = el.getAttribute('data-color');
      if (color && color !== '' && color !== 'rgba(0,0,0,0)') {
        entry.color = color;
      }
      const link = el.getAttribute('data-link');
      if (link && link !== '') {
        entry.link = link;
        if (el.getAttribute('data-link-new-tab') === 'true') {
          entry.linkTarget = '_blank';
        }
      }
      values[code] = entry;
      tooltipContent[code] = {
        title: el.getAttribute('data-title') || '',
        html: el.querySelector('.world-map__tooltip-content')?.innerHTML || '',
      };
    });

    mapContainer.innerHTML = '';

    this.mapInstance = new svgMap({
      targetElementID: mapContainer.id,
      initialZoom: 1.06,
      colorMax: settings.colorHighlight || '#FFD500',
      colorMin: settings.colorHighlight || '#FFD500',
      colorNoData: settings.colorNoData || '#797979',
      hideFlag: true,
      mouseWheelZoomEnabled: settings.mouseWheelZoomEnabled !== false,
      mouseWheelZoomWithKey: settings.mouseWheelZoomWithKey || false,
      showZoomReset: settings.showZoomReset || false,
      showContinentSelector: settings.showContinentSelector || false,
      noDataText: '',
      data: {
        data: {
          presence: {
            name: '',
            format: '',
            thresholdMax: 1,
            thresholdMin: 1,
          },
        },
        applyData: 'presence',
        values: values,
      },
      onGetTooltip: function (tooltipDiv, countryID, countryValues) {
        const info = tooltipContent[countryID];
        if (!info) return null;

        const container = document.createElement('div');
        container.className = 'svgMap-tooltip-content-container';

        if (info.title) {
          const titleEl = document.createElement('div');
          titleEl.className = 'svgMap-tooltip-title';
          titleEl.textContent = info.title;
          container.appendChild(titleEl);
        }

        if (info.html) {
          const contentEl = document.createElement('div');
          contentEl.className = 'svgMap-tooltip-content';
          contentEl.innerHTML = info.html;
          container.appendChild(contentEl);
        }

        return container;
      },
    });
  }
}

if (!customElements.get('bb-world-map')) {
  customElements.define('bb-world-map', BBWorldMap);
}

/**
 * Privatkunde/Geschaeftskunde-Switcher: Tooltip per Tap/Klick togglen
 * (Hover/Fokus laeuft rein ueber CSS; noetig fuer Touch-Geraete)
 */
(function () {
  var helpButtons = document.querySelectorAll('.inclvat__help');
  if (!helpButtons.length) return;

  helpButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = btn.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.inclvat__help.is-open').forEach(function (btn) {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.inclvat__help.is-open').forEach(function (btn) {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  });
})();
